module.exports = __webpack_public_path__ + "img/bandicam_00013.ba16415e.png";